import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectItemChange,
        filterChange } from '../../actions';

import TreeView from '@material-ui/lab/TreeView';
import CircularProgress from '@material-ui/core/CircularProgress';
import RecursiveTreeItem from './treeItem.js';
import { MinusSquare, PlusSquare } from './treeButtons.js';
import { findItemProgress } from '../../functions/finder';
import { formatItemProgress } from '../../functions/reformatItemData';
import { FilterActions } from '../../constants/constants.js';

class TreeRoot extends React.Component {


	onNodeSelect = (object, itemId) => {
        let itemContainer = object.currentTarget.getElementsByClassName('item-name')
		if(itemId === 'root'){
            this.props.selectItemChange('unset')
            this.handleRelationshipsChange({})
			return
		}
		let name = itemContainer.length === 0 ? object.currentTarget.textContent : itemContainer[0].textContent
        if (Object.keys(this.props.itemsData).length > 0) {
			let progress = findItemProgress(itemId, this.props.itemsProgress)
		    let item = formatItemProgress(itemId, name, progress)
		    this.props.selectItemChange(item)
            this.handleRelationshipsChange(this.props.itemsData.relationships[itemId])
		}
	}

    handleRelationshipsChange = (relationships) => {
        let levelIds = []
        let categoryIds = []
        let protocolIds = []
        let zoneIds = []

        Object.values(relationships).forEach(relationship => {
            switch (relationship.attributes.element_type) {
                case 'levels':
                    levelIds.push(relationship.attributes.element_id)
                    break;
                case 'card_categories':
                    categoryIds.push(relationship.attributes.element_id)
                    break;
                case 'protocols':
                    protocolIds.push(relationship.attributes.element_id)
                    break;
                case 'zones':
                    zoneIds.push(relationship.attributes.element_id)
                    break;
                default:
                    break;
            }
        })

        this.handleLevelChange(levelIds)
        this.handleCategoriesChange(categoryIds)
        this.handleProtocolsChange(protocolIds)
        this.handleZonesChange(zoneIds)
    } 

    handleLevelChange = (levelIds) => {
        if (levelIds.length === 0) {
            this.props.filterChange(FilterActions.LEVELS, [])
            return
        }
        let stageIds = [...this.props.stageIds]
        for (const levelId of levelIds) {
            let levelData = this.props.projectData.levels[levelId.toString()]
            if (!stageIds.includes(levelData.attributes.stage_id)) {
                stageIds.push(levelData.attributes.stage_id)
            }
        }
        this.props.filterChange(FilterActions.STAGES, stageIds)
        this.props.filterChange(FilterActions.LEVELS, levelIds)
    }

    handleCategoriesChange = (categoryIds) => {
        let cardCategories = this.props.projectData.card_categories
        let selectedCategories = []
        for (const categoryId of categoryIds) {
            let cardCategory = cardCategories[categoryId.toString()]
            if (this.props.stageIds.includes(cardCategory.attributes.stage_id)
                || this.props.stageIds.length === 0) {
                selectedCategories.push(categoryId)
            }
        }
        this.props.filterChange(FilterActions.CARD_CATEGORIES, selectedCategories)
    }

    handleProtocolsChange = (protocolIds) => {
        let protocols = {}
        for (const stageData of Object.values(this.props.projectData.stages)) {
            if (this.props.stageIds.length === 0 || this.props.stageIds.includes(stageData.id)) {
                protocols = {
                    ...protocols,
                    ...stageData.protocols
                }
            }
        }
        let selectedProtocols = []
        let protocolgroupIds = []
        for (const protocolId of protocolIds) {
            let protocol = protocols[protocolId.toString()]
            if (protocol) {
                selectedProtocols.push(protocolId)
                let protocolgroupId = protocol.attributes.protocolgroup_id
                if (!protocolgroupIds.includes(protocolgroupId)) {
                    protocolgroupIds.push(protocolgroupId)
                }
            }
        }
        this.props.filterChange(FilterActions.PROTOCOLGROUPS, protocolgroupIds)
        this.props.filterChange(FilterActions.PROTOCOLS, selectedProtocols)
    }

    handleZonesChange = (zoneIds) => {
        this.props.filterChange(FilterActions.ZONES, zoneIds)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.itemsProgress === 'unset') return 
        if (prevProps.itemsProgress !== this.props.itemsProgress) {
            if (this.props.selectedItem !== 'unset') {
                let progress = findItemProgress(this.props.selectedItem.itemId, this.props.itemsProgress)
                let item = formatItemProgress(this.props.selectedItem.itemId, this.props.selectedItem.name, progress)
                this.props.selectItemChange(item)
            }
        }
    }

	render(){
		let render = false;
		if (this.props.itemsData !== "unset" 
            && this.props.itemsProgress !== "unset"
            && Object.keys(this.props.qualityProgress).length > 0) {
			render = true;
		}

		return ( render ? (
            <div>
                <div className='position-relative'>
                    <TreeView
                        defaultExpanded={['1']}
                        defaultCollapseIcon={<MinusSquare />}
                        defaultExpandIcon={<PlusSquare />}
                        onNodeSelect={this.onNodeSelect}
                    >
                        <RecursiveTreeItem/>
                    </TreeView>	
                    { this.props.loadingItems ? (
                    <div className="circular-progress-center position-absolute">
                        <CircularProgress/>
                    </div>	
                    ) : null }	
                </div>
            </div>
            ) : (
            <div>
                <div className="circular-progress-center">
                    <CircularProgress/>
                </div>
            </div>
		)
		);
	}

}

function mapStateToProps(state) {
	return {
        projectData     : state.projectData,
        stageIds        : state.filters.stageIds,
		itemsData       : state.itemsData,
		itemsProgress   : state.itemsProgress,
        loadingItems    : state.switches.loadingItems,
        selectedItem    : state.selectedItem,
        qualityProgress : state.qualityProgress
	}
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange : filterChange,
		selectItemChange : selectItemChange,
    }, dispatch)
}



export default connect(mapStateToProps, matchDispatchToProps)(TreeRoot);
